import React, { PureComponent, useRef, useEffect } from 'react';
import { CenterPage, CenterBottom, ChartContainer } from './style';
import Map from './charts/Map';
import { connect } from 'dva';
//import * as echarts from 'echarts'; // 引入 ECharts
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/grid';
import { getLeftPageData } from '../../services/index';

class index extends PureComponent {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
    this.chartInstance = null;
    this.state = {
      // detailsList:'',
      // num1:251157602.65,
      // num2:18418429,
      // num3:2353891,
      // num4:2202905,
      // num5:2202905,
      // num6:2202905,
      //hourlyEarnings: Array(24).fill(0), // 24小时收益数据
      currentvalue: 0,
      currenttime: -1,
      hourlyEarnings: [],
      //lastUpdateTime: new Date().toLocaleTimeString()
      chartInitialized: false,
      //initstatus: false,
    };
  }

  // 设置时间
  // componentDidMount() {
  //   const hourlyEarnings = this.getInitialData();
  //   this.setState({
  //     hourlyEarnings,
  //     chartInitialized: true
  //   });
  //   this.setCenter();
  //   this.initChart();
  //   this.startDataUpdate();
  // }

  async componentDidMount() {
    try {
      // 等待数据获取完成
      const hourlyEarnings = await this.getInitialData();

      // 数据获取完成后再更新状态
      this.setState({
        hourlyEarnings,
        chartInitialized: true
      });

      // 只有数据准备好后才初始化图表和开始更新
      this.setCenter();
      this.initChart();
      this.startDataUpdate();
    } catch (error) {
      console.error('初始化数据失败:', error);
      // 处理错误情况，如显示错误提示
    }
  }

  componentWillUnmount() {
    clearInterval(this.updateInterval);
    clearInterval(this.timing); // 清除setCenter的定时器
    // 销毁 ECharts 实例
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
    window.removeEventListener('resize', this.handleResize); // 移除resize监听
  }

  // 初始化 ECharts
  initChart() {
    // 获取 DOM 元素
    const chartDom = this.chartRef.current;
    if (!chartDom) return;

    // 初始化图表
    this.chartInstance = echarts.init(chartDom);

    // 设置图表配置
    const option = {
      title: {
        //text: '今日收益统计(0-23时)',
        text: '全时段订单分析',
        left: 'center',
        //color: '#fff',
        textStyle: {
          color: '#FFFFFF', // 标题文字颜色，设为明亮的白色
          fontSize: 16
        },
        left: 'center' // 标题居中显示，可根据需求调整
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        formatter: (params) => {
          const param = params[0];
          return `${param.name}<br/>订单: ${param.value} 笔`;
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: Array(24).fill('').map((_, i) => `${i}时`),
        axisLabel: {
          color: '#FFFFFF', // x 轴文字颜色，设为明亮的白色
          interval: 1 // 显示所有刻度标签
        }
      },
      yAxis: {
        type: 'value',
        name: '订单量(笔)',
        min: 0,
        axisLabel: {
          color: '#FFFFFF', // x 轴文字颜色，设为明亮的白色
          //interval: 1 // 显示所有刻度标签
        }
      },
      // series: [{
      //   name: '收益',
      //   type: 'bar',
      //   data: Array(24).fill(0),
      itemStyle: {
        // 上面的渐变颜色配置...
        borderColor: '#fff', // 柱体边框颜色
        borderWidth: 1, // 边框宽度
        borderRadius: 5 // 柱体圆角半径，让柱子变成圆角矩形
      },
      //   animationDuration: 1000,
      //   animationEasing: 'elasticOut'
      // }]
      // 其他配置...
      series: [
        {
          name: '收益',
          type: 'bar',
          data: Array(24).fill(0),
          barCategoryGap: '25%',// 调整同系列类目间的柱体间距，可按需改百分比
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: '#3399ff' // 起始颜色调整
              },
              {
                offset: 0.4,
                color: '#66ccff' // 新增中间过渡颜色
              },
              {
                offset: 1,
                color: '#99eeff' // 结束颜色调整
              }
            ]
          },
          emphasis: {
            itemStyle: {
              color: '#2f89cf', // 高亮主色
              borderColor: '#ffd700', // 高亮时边框颜色
              borderWidth: 2, // 高亮时边框宽度
              boxShadow: '0 0 10px rgba(255, 215, 0, 0.5)' // 高亮时的阴影效果
            }
          },
        },
        {
          name: '趋势',
          type: 'line',
          data: Array(24).fill(0),
          smooth: true,
          lineStyle: {
            color: '#f56c6c',
            width: 2
          },
          symbol: 'circle',
          symbolSize: 6,
          showSymbol: false
        }
      ]
    };

    // 应用配置
    this.chartInstance.setOption(option);
    this.setState({ chartInitialized: true });

    // 监听窗口大小变化，自适应图表
    window.addEventListener('resize', this.handleResize);
  }

  // 窗口大小变化时调整图表
  handleResize = () => {
    if (this.chartInstance) {
      this.chartInstance.resize();
    }
  }

  // 启动数据更新
  startDataUpdate = () => {
    this.updateInterval = setInterval(() => {
      const { hourlyEarnings,currentvalue,currenttime } = this.state;
      //const newHourlyEarnings = [...(hourlyEarnings ?? [])];
      const newHourlyEarnings = [...hourlyEarnings];
      // 生成当前小时的随机收益
      const currentHour = new Date().getHours();
      let minute = new Date().getMinutes();
      let currenttime1 = currenttime;
      let currentvalue1 = currentvalue;
      if(currentHour !== currenttime && currenttime !== -1){
        let bili = 1;
        if(currentHour <= 4){
          bili = 0.5;
        }else if(currentHour <= 8){
          bili = 0.3;
        }else if(currentHour <= 20){
          bili = 1.2;
        }else if(currentHour <= 23){
          bili = 1.5;
        }
        if (minute < 10) {
          currentvalue1 = 1200*bili;
        } else if (minute < 20) {
          currentvalue1 = 2500*bili;
        } else if (minute < 30) {
          currentvalue1 = 3000*bili;
        } else if (minute < 40) {
          currentvalue1 = 4000*bili;
        } else if (minute < 50) {
          currentvalue1 = 5000*bili;
        } else {
          currentvalue1 = 6000*bili;
        }
        currenttime1 = currentHour;
      }
      let randomEarnings = Math.floor(Math.random() * 10) + 2;
      if(currentHour>=8 && currentHour<=20){
         randomEarnings = Math.floor(Math.random() * 10) + Math.floor(currentHour/2) + 2;
      }else if(currentHour>20){
         randomEarnings = Math.floor(Math.random() * 10) + 5;
      }
      //const randomEarnings = this.generateRandomEarnings();
      newHourlyEarnings[currentHour] =  currentvalue1 + randomEarnings;
      //newHourlyEarnings[currentHour] = currentvalue + Math.floor(Math.random() * 100) + 1;

      // 更新状态和图表
      this.setState({ hourlyEarnings: newHourlyEarnings, currentvalue: newHourlyEarnings[currentHour], currenttime: currenttime1 });

      if (this.chartInstance) {
        this.chartInstance.setOption({
          series: [{
            data: newHourlyEarnings
          }]
        });
      }
    }, 3000); // 每3秒更新一次数据
  }

  // 生成随机收益（保留一位小数）
  // generateRandomEarnings() {
  //   const baseEarnings = 1000 + Math.random() * 4000;
  //   const fluctuation = (Math.random() * 1000 - 500);
  //   return parseFloat((baseEarnings + fluctuation).toFixed(1));
  // }

   // 初始化24小时模拟数据（过去时间有历史数据，当前时间之后为0）
  // async getInitialData(){
  //     //data: Array(24).fill('').map((_, i) => `${i}时`),
  //     const now = new Date();
  //     const currentHour = now.getHours();
  //     const minute = now.getMinutes();
  //      // 根据当前分钟确定初始值
  //      let initialValue = 0;
  //      if (minute < 10) {
  //        initialValue = 1200;
  //      } else if (minute < 20) {
  //        initialValue = 2500;
  //      } else if (minute < 30) {
  //        initialValue = 3000;
  //      } else if (minute < 40) {
  //        initialValue = 4000;
  //      } else if (minute < 50) {
  //        initialValue = 5000;
  //      } else {
  //        initialValue = 6000;
  //      }
  //     //const newcurrentvalue = initialValue + Math.floor(Math.random() * 100) + 1;
  //     // this.setState({
  //     //    currentvalue: initialValue
  //     // });
  //    let data1 = null;
  //    const cacheKey = 'leftPageData';
  //    const cachedData = localStorage.getItem(cacheKey);
  //    const parsed = JSON.parse(cachedData);
  //    let data = Array(24).fill(0);
  //    if(parsed) {
  //      const {data: cachedDataValue} = parsed;
  //      let segments = {A: [], B: [], C: []};
  //      data1 = cachedDataValue;
  //    }else{
  //      data1 = await getLeftPageData();
  //    }
  //    if(data1 && typeof data1.data === 'object' && data1.data.also_number) {
  //      //let one = Math.round( data.data.also_number/currentHour*10)/10;
  //      let total = data1.data.also_number;
  //      const targetHours = Array.from({ length: currentHour + 1 }, (_, i) => i); // 0到currentHour的时段
  //
  //      // 2. 在当前时段范围内，划分A/B/C类（仅包含目标时段内的小时）
  //      // segments = {
  //      //   A: [3, 4, 5].filter(h => targetHours.includes(h)), // 3-6点（仅保留在目标时段内的小时）
  //      //   B: [1, 2].filter(h => targetHours.includes(h)),    // 1-3点（仅保留1、2点）
  //      //   C: targetHours.filter(h => !segments.A.includes(h) && !segments.B.includes(h)) // 其他时段
  //      // };
  //      const segments = {
  //        A: [3, 4, 5].filter(h => targetHours.includes(h)),
  //        B: [1, 2].filter(h => targetHours.includes(h)),
  //        C: [] // 先初始化为空数组
  //      };
  //
  //      // 此时 segments.A 和 segments.B 已存在，可以安全引用
  //      segments.C = targetHours.filter(h =>
  //        !segments.A.includes(h) && !segments.B.includes(h)
  //      );
  //
  //      // 3. 处理“某类不存在”的特殊情况（如当前2点，A类还未出现）
  //      const hasA = segments.A.length > 0;
  //      const hasB = segments.B.length > 0;
  //      const hasC = segments.C.length > 0;
  //
  //      // 4. 动态计算各类占比（确保A < B < C，若某类不存在则调整）
  //      let ratioA = 0, ratioB = 0, ratioC = 0;
  //      if (hasA && hasB && hasC) {
  //        // 三类都存在：A占10%，B占15%，C占75%（确保A < B < C）
  //        if(currentHour>5 && currentHour<=8) {
  //            ratioA = 0.1;
  //            ratioB = 0.15;
  //            ratioC = 1 - ratioA - ratioB;
  //        }else if(currentHour>8 && currentHour<=14){
  //            ratioA = 0.08;
  //            ratioB = 0.1;
  //            ratioC = 1 - ratioA - ratioB;
  //        }else if(currentHour>14 && currentHour<=20){
  //            ratioA = 0.03;
  //            ratioB = 0.05;
  //            ratioC = 1 - ratioA - ratioB;
  //        }else{
  //            ratioA = 0.02;
  //            ratioB = 0.03;
  //            ratioC = 1 - ratioA - ratioB;
  //        }
  //      } else if (hasB && hasC && !hasA) {
  //        // 只有B和C：B占20%，C占80%（B < C）
  //        ratioB = 0.4;
  //        ratioC = 1 - ratioB;
  //      } else {
  //        // 其他极端情况（如仅A或仅B），默认平均分配
  //        const allHours = [...segments.A, ...segments.B, ...segments.C];
  //        const avgRatio = 1 / allHours.length;
  //        ratioA = segments.A.length * avgRatio;
  //        ratioB = segments.B.length * avgRatio;
  //        ratioC = segments.C.length * avgRatio;
  //      }
  //      // console.log(ratioA,ratioB,ratioC);
  //      // console.log(segments.A, segments.B, segments.C);
  //
  //    // else if (hasC && !hasA && !hasB) {
  //    //     // 只有C：C占100%
  //    //     ratioC = 1;
  //    //   } else if (hasA && hasC && !hasB) {
  //    //     // 只有A和C：A占20%，C占80%（A < C）
  //    //     ratioA = 0.2;
  //    //     ratioC = 1 - ratioA;
  //    //   }
  //
  //      // 5. 计算各类总金额（四舍五入，确保总和接近total）
  //      const sumA = Math.round(total * ratioA);
  //      const sumB = Math.round(total * ratioB);
  //      const sumC = total - sumA - sumB; // 确保总和严格等于total
  //      //console.log(sumA,sumB,sumC);
  //
  //      // // 6. 同类时段内随机分配（总和固定，单个时段值随机）
  //      // const distributeWithinGroup = (hours, groupTotal) => {
  //      //   if (hours.length === 0) return {};
  //      //   // 生成随机基础值（1-10），确保总和可调整到groupTotal
  //      //   let values = hours.map(() => Math.floor(Math.random() * 10) + 1);
  //      //   const sumValues = values.reduce((a, b) => a + b, 0);
  //      //   // 按比例放大到groupTotal，并修正误差
  //      //   values = values.map(v => Math.round(v * (groupTotal / sumValues)));
  //      //   const diff = groupTotal - values.reduce((a, b) => a + b, 0);
  //      //   values[0] += diff; // 误差加到第一个元素
  //      //   // 转为 {小时: 值} 格式
  //      //   return hours.reduce((obj, hour, i) => {
  //      //     obj[hour] = values[i];
  //      //     return obj;
  //      //   }, {});
  //      // };
  //
  //      // 调整C类时段的随机生成逻辑
  //      const distributeWithinGroup = (hours, groupTotal, isCGroup = false) => {
  //        if (hours.length === 0) return {};
  //
  //        // 基础随机值范围
  //        const baseMin = isCGroup ? 1 : 1;    // C类从1开始
  //        const baseMax = isCGroup ? 30 : 10;  // C类到30，其他类保持10
  //
  //        // 生成随机基础值
  //        let values = hours.map(() => Math.floor(Math.random() * (baseMax - baseMin + 1)) + baseMin);
  //        // let values = hours.map(hour => {
  //        //    if(hour == 6 || hour == 7 || hour == 8){
  //        //      return Math.floor(Math.random() * 5 + 1) + baseMin;
  //        //    }else{
  //        //      return Math.floor(Math.random() * (baseMax - baseMin + 1)) + baseMin;
  //        //    }
  //        // });
  //
  //        // 对C类时段增加额外的波动（可选）
  //        if (isCGroup) {
  //          values = values.map(v => {
  //            // 每小时有50%概率进一步放大2-4倍
  //            if (Math.random() > 0.5) {
  //              return v * (Math.floor(Math.random() * 3) + 2); // 2-4倍
  //            }
  //            return v;
  //          });
  //        }
  //
  //        // 后续逻辑保持不变
  //        const sumValues = values.reduce((a, b) => a + b, 0);
  //        values = values.map(v => Math.round(v * (groupTotal / sumValues)));
  //        const diff = groupTotal - values.reduce((a, b) => a + b, 0);
  //        values[0] += diff;
  //
  //        return hours.reduce((obj, hour, i) => {
  //          obj[hour] = values[i];
  //          return obj;
  //        }, {});
  //      };
  //
  //      // const distributeWithinGroup = (hours, groupTotal, isCGroup = false) => {
  //      //   if (hours.length === 0) return {};
  //      //
  //      //   // 为C类时段定义不同的权重（示例：早高峰、晚高峰权重高）
  //      //   const timeWeights = isCGroup ? {
  //      //     7: 3, 8: 3,   // 早高峰
  //      //     18: 3, 19: 3, // 晚高峰
  //      //     12: 2,        // 中午
  //      //     // 默认权重为1（其他时段）
  //      //   } : {};
  //      //
  //      //   // 生成带权重的随机值
  //      //   let values = hours.map(hour => {
  //      //     const weight = timeWeights[hour] || 1;
  //      //     return Math.floor(Math.random() * 10 + 1) * weight;
  //      //   });
  //      //
  //      //   // 后续逻辑保持不变
  //      //   const sumValues = values.reduce((a, b) => a + b, 0);
  //      //   values = values.map(v => Math.round(v * (groupTotal / sumValues)));
  //      //   const diff = groupTotal - values.reduce((a, b) => a + b, 0);
  //      //   values[0] += diff;
  //      //
  //      //   return hours.reduce((obj, hour, i) => {
  //      //     obj[hour] = values[i];
  //      //     return obj;
  //      //   }, {});
  //      // };
  //
  //      // 7. 分配各时段
  //      const aValues = distributeWithinGroup(segments.A, sumA);
  //      const bValues = distributeWithinGroup(segments.B, sumB);
  //      //const cValues = distributeWithinGroup(segments.C, sumC);
  //      const cValues = distributeWithinGroup(segments.C, sumC, true); // 标记为C类，启用差异化逻辑
  //      //console.log(aValues,bValues,cValues);
  //
  //      //8. 生成结果数组（24小时，仅目标时段有值）
  //      Object.entries(cValues).forEach(([h, val]) => data[h] = val);
  //      Object.entries(aValues).forEach(([h, val]) => data[h] = val);
  //      Object.entries(bValues).forEach(([h, val]) => data[h] = val);
  //
  //    }else {
  //      data = data.map((_, i) => {
  //        if (i < currentHour) {
  //          // 过去时间：生成随机历史数据（5000-15000之间）
  //          if (i >= 1 && i <= 3) {
  //            return Math.floor(Math.random() * 5000) + 3000;
  //          } else if (i >= 3 && i <= 6) {
  //            return Math.floor(Math.random() * 2000) + 2000;
  //          } else if (i >= 6 && i <= 8) {
  //            return Math.floor(Math.random() * 5000) + 2000;
  //          } else {
  //            return Math.floor(Math.random() * 10000) + 4000;
  //          }
  //        } else if (i === currentHour) {
  //          // 当前时间：初始值+动态增长
  //          return initialValue;
  //        } else {
  //          // 未来时间：尚未有数据
  //          return 0;
  //        }
  //      });
  //    }
  //      //this.currentvalue = initialValue;
  //      this.setState({
  //        currentvalue: initialValue
  //      });
  //      return data;
  // }
// 初始化24小时模拟数据（过去时间有历史数据，当前时间之后为0）
  async getInitialData() {
    // 等待3秒
    await new Promise(resolve => setTimeout(resolve, 2000));
    const now = new Date();
    const currentHour = now.getHours();
    const minute = now.getMinutes();

    let data1 = null;
    const cacheKey = 'leftPageData';
    const cachedData = localStorage.getItem(cacheKey);
    //const parsed = JSON.parse(cachedData);
    const { parsed, updateTime, saveTime } = JSON.parse(cachedData);
    let data = Array(24).fill(0);

    if(parsed) {
      const {data: cachedDataValue} = parsed;
      data1 = cachedDataValue;
    }else{
      data1 = await getLeftPageData();
    }
    // 根据当前分钟确定初始值（用于当前小时的动态增长）
    let initialValue = 0;
    let bili = 1;
    if(currentHour <= 4){
      bili = 0.5;
    }else if(currentHour <= 8){
      bili = 0.3;
    }else if(currentHour <= 20){
      bili = 1.2;
    }else if(currentHour <= 23){
      bili = 1.5;
    }
    if (minute < 10) {
      initialValue = 1200*bili;
    } else if (minute < 20) {
      initialValue = 2500*bili;
    } else if (minute < 30) {
      initialValue = 3000*bili;
    } else if (minute < 40) {
      initialValue = 4000*bili;
    } else if (minute < 50) {
      initialValue = 5000*bili;
    } else {
      initialValue = 6000*bili;
    }
    if(data1 && typeof data1.data === 'object' && data1.data.also_number) {
      let total = data1.data.also_number;
      const now = Date.now();
      if(now-updateTime<=30000 && total<10000) {
          total = Math.round(data1.data.also_number / 24 * 30 * currentHour);
      }

      // 定义各时间段的比例（基于完整24小时）
      const fullDayRatios = {
        '0-4': 0.15,
        '4-8': 0.05,
        '8-20': 0.5,
        '20-24': 0.3
      };

      // 计算当前时间覆盖了哪些时间段
      const coveredPeriods = [];
      if (currentHour >= 0) coveredPeriods.push('0-4');
      if (currentHour >= 4) coveredPeriods.push('4-8');
      if (currentHour >= 8) coveredPeriods.push('8-20');
      if (currentHour >= 20) coveredPeriods.push('20-24');

      // 计算覆盖时间段的总比例
      let coveredRatio = 0;
      coveredPeriods.forEach(period => {
        // 计算该时间段在当前时间点前的实际覆盖比例
        const [startHour, endHour] = period.split('-').map(Number);
        const actualEndHour = Math.min(endHour, currentHour + 1);
        const coveredHours = actualEndHour - startHour;
        const totalHours = endHour - startHour;
        const periodRatio = fullDayRatios[period] * (coveredHours / totalHours);
        coveredRatio += periodRatio;
      });

      // 重新计算各时间段的实际比例（确保总和为1）
      const actualRatios = {};
      coveredPeriods.forEach(period => {
        const [startHour, endHour] = period.split('-').map(Number);
        const actualEndHour = Math.min(endHour, currentHour + 1);
        const coveredHours = actualEndHour - startHour;
        const totalHours = endHour - startHour;

        const periodRatio = fullDayRatios[period] * (coveredHours / totalHours);
        actualRatios[period] = periodRatio / coveredRatio;
      });

      // 为每个时间段分配订单量
      coveredPeriods.forEach(period => {
        const [startHour, endHour] = period.split('-').map(Number);
        const actualEndHour = Math.min(endHour, currentHour + 1);
        const hoursInPeriod = actualEndHour - startHour;

        if (hoursInPeriod <= 0) return;

        // 计算该时间段应分配的订单量
        const periodTotal = Math.round(total * actualRatios[period]);

        let periodData = [];

        if (period === '0-4') {
          // 0-4点：下降到1000单左右
          const startValue = 3000; // 起始值
          const endValue = 1000;   // 结束值

          for (let i = 0; i < hoursInPeriod; i++) {
            // 线性下降，添加随机波动
            const progress = i / (hoursInPeriod - 1);
            const baseValue = startValue - (startValue - endValue) * progress;
            const fluctuation = Math.random() * 200 - 100; // ±100的随机波动
            periodData.push(Math.max(800, Math.round(baseValue + fluctuation)));
          }
        }
        else if (period === '4-8') {
          // 4-8点：低值（500-1000）
          for (let i = 0; i < hoursInPeriod; i++) {
            periodData.push(Math.floor(Math.random() * 500) + 500); // 500-1000之间
          }
        }
        else if (period === '8-20') {
          // 8-20点：递增到15000左右
          const startValue = 1000;
          const endValue = 15000;

          for (let i = 0; i < hoursInPeriod; i++) {
            // 非线性递增（前期增长慢，后期增长快）
            const progress = i / (hoursInPeriod - 1);
            const curvedProgress = progress * progress; // 使用平方函数使增长加速
            const baseValue = startValue + (endValue - startValue) * curvedProgress;
            const fluctuation = Math.random() * 1000 - 500; // ±500的随机波动

            // 确保整体趋势是上升的，但允许个别小时小幅下降
            if (i > 0 && periodData[i-1] > baseValue + fluctuation) {
              periodData.push(Math.round(periodData[i-1] * 0.95)); // 最多下降5%
            } else {
              periodData.push(Math.round(baseValue + fluctuation));
            }
          }
        }
        else if (period === '20-24') {
          // 20-24点：互有高低
          const baseValue = 15000;

          for (let i = 0; i < hoursInPeriod; i++) {
            const fluctuation = Math.random() * 3000 - 1500; // ±1500的随机波动
            periodData.push(Math.max(12000, Math.round(baseValue + fluctuation)));
          }
        }

        // // 调整数据，使总和精确等于periodTotal
        // const sum = periodData.reduce((a, b) => a + b, 0);
        // if (sum !== periodTotal && sum > 0) {
        //   const adjustmentFactor = periodTotal / sum;
        //   periodData = periodData.map(val => Math.round(val * adjustmentFactor));
        //
        //   // 修正可能的舍入误差
        //   const adjustedSum = periodData.reduce((a, b) => a + b, 0);
        //   const diff = periodTotal - adjustedSum;
        //   if (diff !== 0 && periodData.length > 0) {
        //     periodData[0] += diff; // 将误差加到第一个元素
        //   }
        // }
        //
        // // 将生成的数据填充到结果数组
        // for (let i = 0; i < hoursInPeriod; i++) {
        //   const hour = startHour + i;
        //   if (hour <= currentHour) {
        //     data[hour] = Math.round(periodData[i]);
        //   }
        // }
        // 调整数据，使总和精确等于periodTotal
        const sum = periodData.reduce((a, b) => a + b, 0);
        if (sum !== periodTotal && sum > 0) {
          const adjustmentFactor = periodTotal / sum;
          periodData = periodData.map(val => Math.round(val * adjustmentFactor));

          // 修正可能的舍入误差
          const adjustedSum = periodData.reduce((a, b) => a + b, 0);
          const diff = periodTotal - adjustedSum;
          if (diff !== 0 && periodData.length > 0) {
            periodData[0] += diff; // 将误差加到第一个元素
          }
        }

        // 确保periodData中的所有值都是整数
        periodData = periodData.map(val => {
          if (!Number.isInteger(val)) {
            // 使用Number.EPSILON处理极小的浮点数误差
            const rounded = Math.round(val);
            if (Math.abs(val - rounded) < Number.EPSILON) {
              return rounded;
            }
            console.warn('Unexpected non-integer value:', val);
            return rounded; // 强制取整
          }
          return val;
        });

        // 将生成的数据填充到结果数组（加强版整数检查）
        for (let i = 0; i < hoursInPeriod; i++) {
          const hour = startHour + i;
          if (hour <= currentHour) {
            // 双重检查并使用Number.parseInt确保整数
            const value = periodData[i];
            if (Number.isInteger(value)) {
              data[hour] = value;
            } else {
              // 处理非整数情况（理论上不会执行到这里）
              data[hour] = Number.parseInt(value, 10);
              console.warn(`强制转换非整数 ${value} 为 ${data[hour]}`);
            }
          }
        }
      });
      //console.log(data);
      // 设置当前小时的值
      if (currentHour < 24) {
        data[currentHour] = initialValue;

        // 调整其他小时的数据，确保总和等于total
        const sumWithoutCurrent = data.reduce((sum, val, idx) => idx !== currentHour ? sum + val : sum, 0);
        let adjustmentNeeded = total - sumWithoutCurrent - initialValue;

        if (adjustmentNeeded !== 0 && currentHour > 0) {
          // 从当前小时之前的最后一个小时开始调整
          let adjustIdx = currentHour - 1;
          while (adjustmentNeeded !== 0 && adjustIdx >= 0) {
            const adjustAmount = Math.min(Math.abs(adjustmentNeeded), data[adjustIdx] * 0.1); // 每次最多调整10%
            data[adjustIdx] += adjustmentNeeded > 0 ? adjustAmount : -adjustAmount;
            adjustmentNeeded += adjustmentNeeded > 0 ? -adjustAmount : adjustAmount;
            adjustIdx--;
          }
        }
      }

      this.setState({
        currentvalue: initialValue,
        currenttime: currentHour
      });
      data = data.map(val => {
        return Math.round(val);
      });
      return data;
    } else {
      // 备用方案：随机生成符合趋势的数据
      data = data.map((_, i) => {
        if (i < currentHour) {
          if (i >= 0 && i <= 4) {
            // 0-4点：下降到1000单左右
            return Math.floor(3000 - (i * 500) + Math.random() * 200);
          } else if (i > 4 && i <= 8) {
            // 4-8点：低值（500-1000）
            return Math.floor(Math.random() * 500) + 500;
          } else if (i > 8 && i <= 20) {
            // 8-20点：递增到15000左右
            return Math.floor(1000 + ((i-8) * 1200) + Math.random() * 1000);
          } else {
            // 20-24点：互有高低
            return Math.floor(15000 + Math.random() * 3000 - 1500);
          }
        } else if (i === currentHour) {
          // 当前时间：初始值
          return initialValue;
        } else {
          // 未来时间：尚未有数据
          return 0;
        }
      });

      this.setState({
        currentvalue: initialValue,
        currenttime: currentHour,
        initstatus: true
      });

      return data;
    }
  }



  setCenter() {
    this.timing = setInterval(() => {
      this.setState({
        // detailsList: [
        //   {
        //     //
        //     title: '总销售额情况',
        //     number: this.state.num1 = parseInt( this.state.num1 + Math.floor(Math.random() * 100 )) +  parseFloat((Math.random()).toFixed(2)),
        //     unit: '点击/张',
        //   },
        //   {
        //     title: '总订单量情况',
        //     number: this.state.num2 = this.state.num2 + Math.floor(Math.random() * (10 - 1) + 1),
        //     unit: '点击/个',
        //   },
        //   {
        //     title: '设备总数',
        //     number: this.state.num3 = this.state.num3 + Math.floor(Math.random() * (10 - 1) + 1),
        //     unit: '点击/篇',
        //   },
        //   {
        //     title: '设备运营总数',
        //     number: this.state.num4 = this.state.num4 + Math.floor(Math.random() * (10 - 1) + 1),
        //     unit: '攻击/小时',
        //   },
        // ],

        "mapData": {
          "moveLines": [{
            "fromName": "深圳",
            "toName": "延寿",
            "coords": [
              [114.057868, 22.543099],
              [128.331644, 45.451897]
            ]
          }, {
            "fromName": "深圳",
            "toName": "临江",
            "coords": [
              [114.057868, 22.543099],
              [126.918087, 41.811979]
            ]
          }, {
            "fromName": "深圳",
            "toName": "嘉兴",
            "coords": [
              [114.057868, 22.543099],
              [120.755486, 30.746129]
            ]
          }, {
            "fromName": "深圳",
            "toName": "四平",
            "coords": [
              [114.057868, 22.543099],
              [124.350398, 43.16642]
            ]
          }, {
            "fromName": "深圳",
            "toName": "营口",
            "coords": [
              [114.057868, 22.543099],
              [122.235418, 40.667012]
            ]
          }, {
            "fromName": "深圳",
            "toName": "密云",
            "coords": [
              [114.057868, 22.543099],
              [116.801346, 40.35874]
            ]
          }, {
            "fromName": "深圳",
            "toName": "威海",
            "coords": [
              [114.057868, 22.543099],
              [122.12042, 37.513068]
            ]
          }, {
            "fromName": "深圳",
            "toName": "杭州",
            "coords": [
              [114.057868, 22.543099],
              [120.15507, 30.274085]
            ]
          }, {
            "fromName": "深圳",
            "toName": "集安",
            "coords": [
              [114.057868, 22.543099],
              [126.194031, 41.125307]
            ]
          }, {
            "fromName": "深圳",
            "toName": "贵阳",
            "coords": [
              [114.057868, 22.543099],
              [106.630154, 26.647661]
            ]
          }, {
            "fromName": "深圳",
            "toName": "抚顺",
            "coords": [
              [114.057868, 22.543099],
              [123.957208, 41.880872]
            ]
          }, {
            "fromName": "深圳",
            "toName": "海门",
            "coords": [
              [114.057868, 22.543099],
              [121.181615, 31.871173]
            ]
          }, {
            "fromName": "深圳",
            "toName": "珠海",
            "coords": [
              [114.057868, 22.543099],
              [113.576726, 22.270715]
            ]
          }, {
            "fromName": "深圳",
            "toName": "河北",
            "coords": [
              [114.057868, 22.543099],
              [114.475704, 38.584854]
            ]
          }, {
            "fromName": "深圳",
            "toName": "深圳",
            "coords": [
              [114.057868, 22.543099],
              [114.057868, 22.543099]
            ]
          }, {
            "fromName": "深圳",
            "toName": "黄浦",
            "coords": [
              [114.057868, 22.543099],
              [121.484443, 31.231763]
            ]
          }, {
            "fromName": "深圳",
            "toName": "蓬莱",
            "coords": [
              [114.057868, 22.543099],
              [120.758848, 37.810661]
            ]
          }, {
            "fromName": "深圳",
            "toName": "吉林",
            "coords": [
              [114.057868, 22.543099],
              [126.549572, 43.837883]
            ]
          }, {
            "fromName": "深圳",
            "toName": "甘肃",
            "coords": [
              [114.057868, 22.543099],
              [103.826308, 36.059421]
            ]
          }, {
            "fromName": "深圳",
            "toName": "龙井",
            "coords": [
              [114.057868, 22.543099],
              [129.427066, 42.766311]
            ]
          }, {
            "fromName": "深圳",
            "toName": "茂名",
            "coords": [
              [114.057868, 22.543099],
              [110.925456, 21.662999]
            ]
          }, {
            "fromName": "深圳",
            "toName": "丹东",
            "coords": [
              [114.057868, 22.543099],
              [124.354707, 40.0005]
            ]
          }, {
            "fromName": "深圳",
            "toName": "晋中",
            "coords": [
              [114.057868, 22.543099],
              [112.752695, 37.687024]
            ]
          }, {
            "fromName": "深圳",
            "toName": "浙江",
            "coords": [
              [114.057868, 22.543099],
              [120.152792, 30.267447]
            ]
          }, {
            "fromName": "深圳",
            "toName": "海城",
            "coords": [
              [114.057868, 22.543099],
              [122.685217, 40.882377]
            ]
          }, {
            "fromName": "深圳",
            "toName": "溆浦",
            "coords": [
              [114.057868, 22.543099],
              [110.594921, 27.908281]
            ]
          }, {
            "fromName": "深圳",
            "toName": "北京",
            "coords": [
              [114.057868, 22.543099],
              [116.407526, 39.90403]
            ]
          }, {
            "fromName": "深圳",
            "toName": "铁岭",
            "coords": [
              [114.057868, 22.543099],
              [123.726166, 42.223769]
            ]
          }, {
            "fromName": "深圳",
            "toName": "大同",
            "coords": [
              [114.057868, 22.543099],
              [113.61244, 40.040295]
            ]
          }, {
            "fromName": "深圳",
            "toName": "金坛",
            "coords": [
              [114.057868, 22.543099],
              [119.597897, 31.723247]
            ]
          }, {
            "fromName": "深圳",
            "toName": "齐齐哈尔",
            "coords": [
              [114.057868, 22.543099],
              [126.661669, 45.742347]
            ]
          }, {
            "fromName": "深圳",
            "toName": "咸阳",
            "coords": [
              [114.057868, 22.543099],
              [108.708991, 34.329605]
            ]
          }, {
            "fromName": "深圳",
            "toName": "四川",
            "coords": [
              [114.057868, 22.543099],
              [104.075931, 30.651652]
            ]
          }, {
            "fromName": "深圳",
            "toName": "福田",
            "coords": [
              [114.057868, 22.543099],
              [114.055036, 22.52153]
            ]
          }, {
            "fromName": "深圳",
            "toName": "盘锦",
            "coords": [
              [114.057868, 22.543099],
              [122.070714, 41.119997]
            ]
          }, {
            "fromName": "深圳",
            "toName": "中山",
            "coords": [
              [114.057868, 22.543099],
              [113.392782, 22.517646]
            ]
          }, {
            "fromName": "深圳",
            "toName": "福建",
            "coords": [
              [114.057868, 22.543099],
              [119.295144, 26.10078]
            ]
          }, {
            "fromName": "深圳",
            "toName": "泰顺",
            "coords": [
              [114.057868, 22.543099],
              [119.717649, 27.556884]
            ]
          }, {
            "fromName": "深圳",
            "toName": "宝山",
            "coords": [
              [114.057868, 22.543099],
              [131.401589, 46.577167]
            ]
          }, {
            "fromName": "深圳",
            "toName": "庆安",
            "coords": [
              [114.057868, 22.543099],
              [127.507825, 46.880102]
            ]
          }, {
            "fromName": "深圳",
            "toName": "海淀",
            "coords": [
              [114.057868, 22.543099],
              [116.298056, 39.959912]
            ]
          }, {
            "fromName": "深圳",
            "toName": "大兴",
            "coords": [
              [114.057868, 22.543099],
              [116.341395, 39.726929]
            ]
          }, {
            "fromName": "深圳",
            "toName": "桦川",
            "coords": [
              [114.057868, 22.543099],
              [130.719081, 47.023001]
            ]
          }, {
            "fromName": "深圳",
            "toName": "惠州",
            "coords": [
              [114.057868, 22.543099],
              [114.416196, 23.111847]
            ]
          }, {
            "fromName": "深圳",
            "toName": "青岛",
            "coords": [
              [114.057868, 22.543099],
              [120.38264, 36.067082]
            ]
          }, {
            "fromName": "深圳",
            "toName": "朝阳",
            "coords": [
              [114.057868, 22.543099],
              [116.443108, 39.92147]
            ]
          }, {
            "fromName": "深圳",
            "toName": "沈阳",
            "coords": [
              [114.057868, 22.543099],
              [123.431475, 41.805698]
            ]
          }, {
            "fromName": "深圳",
            "toName": "菏泽",
            "coords": [
              [114.057868, 22.543099],
              [115.480656, 35.23375]
            ]
          }, {
            "fromName": "深圳",
            "toName": "南通",
            "coords": [
              [114.057868, 22.543099],
              [120.894291, 31.980172]
            ]
          }, {
            "fromName": "深圳",
            "toName": "南充",
            "coords": [
              [114.057868, 22.543099],
              [106.110698, 30.837793]
            ]
          }, {
            "fromName": "深圳",
            "toName": "双城",
            "coords": [
              [114.057868, 22.543099],
              [126.312745, 45.383263]
            ]
          }, {
            "fromName": "深圳",
            "toName": "南京",
            "coords": [
              [114.057868, 22.543099],
              [118.796877, 32.060255]
            ]
          }, {
            "fromName": "深圳",
            "toName": "新疆",
            "coords": [
              [114.057868, 22.543099],
              [87.627704, 43.793026]
            ]
          }, {
            "fromName": "深圳",
            "toName": "成都",
            "coords": [
              [114.057868, 22.543099],
              [104.066541, 30.572269]
            ]
          }, {
            "fromName": "深圳",
            "toName": "陕西",
            "coords": [
              [114.057868, 22.543099],
              [108.954239, 34.265472]
            ]
          }, {
            "fromName": "深圳",
            "toName": "黄岛",
            "coords": [
              [114.057868, 22.543099],
              [120.04619, 35.872664]
            ]
          }, {
            "fromName": "深圳",
            "toName": "温州",
            "coords": [
              [114.057868, 22.543099],
              [120.699367, 27.994267]
            ]
          }, {
            "fromName": "深圳",
            "toName": "石家庄",
            "coords": [
              [114.057868, 22.543099],
              [114.51486, 38.042307]
            ]
          }, {
            "fromName": "深圳",
            "toName": "邢台",
            "coords": [
              [114.057868, 22.543099],
              [114.504844, 37.070589]
            ]
          }, {
            "fromName": "深圳",
            "toName": "赣州",
            "coords": [
              [114.057868, 22.543099],
              [114.93503, 25.831829]
            ]
          }, {
            "fromName": "深圳",
            "toName": "义乌",
            "coords": [
              [114.057868, 22.543099],
              [120.075058, 29.306841]
            ]
          }, {
            "fromName": "深圳",
            "toName": "南昌",
            "coords": [
              [114.057868, 22.543099],
              [115.858198, 28.682892]
            ]
          }, {
            "fromName": "深圳",
            "toName": "闵行",
            "coords": [
              [114.057868, 22.543099],
              [121.381709, 31.112813]
            ]
          }, {
            "fromName": "深圳",
            "toName": "长宁",
            "coords": [
              [114.057868, 22.543099],
              [121.424624, 31.220367]
            ]
          }, {
            "fromName": "深圳",
            "toName": "道里",
            "coords": [
              [114.057868, 22.543099],
              [126.616957, 45.755777]
            ]
          }, {
            "fromName": "深圳",
            "toName": "乳山",
            "coords": [
              [114.057868, 22.543099],
              [121.539765, 36.919816]
            ]
          }, {
            "fromName": "深圳",
            "toName": "双流",
            "coords": [
              [114.057868, 22.543099],
              [103.923648, 30.574473]
            ]
          }, {
            "fromName": "深圳",
            "toName": "广州",
            "coords": [
              [114.057868, 22.543099],
              [113.264435, 23.129163]
            ]
          }, {
            "fromName": "深圳",
            "toName": "西城",
            "coords": [
              [114.057868, 22.543099],
              [116.365868, 39.912289]
            ]
          }, {
            "fromName": "深圳",
            "toName": "佳木斯",
            "coords": [
              [114.057868, 22.543099],
              [130.318917, 46.799923]
            ]
          }, {
            "fromName": "深圳",
            "toName": "皇姑",
            "coords": [
              [114.057868, 22.543099],
              [123.44197, 41.824796]
            ]
          }, {
            "fromName": "深圳",
            "toName": "榆树",
            "coords": [
              [114.057868, 22.543099],
              [126.533146, 44.840288]
            ]
          }, {
            "fromName": "深圳",
            "toName": "临汾",
            "coords": [
              [114.057868, 22.543099],
              [111.518976, 36.088005]
            ]
          }, {
            "fromName": "深圳",
            "toName": "上海",
            "coords": [
              [114.057868, 22.543099],
              [121.473701, 31.230416]
            ]
          }, {
            "fromName": "深圳",
            "toName": "内蒙古",
            "coords": [
              [114.057868, 22.543099],
              [111.765618, 40.817498]
            ]
          }, {
            "fromName": "深圳",
            "toName": "尚志",
            "coords": [
              [114.057868, 22.543099],
              [128.009895, 45.209586]
            ]
          }, {
            "fromName": "深圳",
            "toName": "湖里",
            "coords": [
              [114.057868, 22.543099],
              [118.146769, 24.512905]
            ]
          }, {
            "fromName": "深圳",
            "toName": "台州",
            "coords": [
              [114.057868, 22.543099],
              [121.420757, 28.656386]
            ]
          }, {
            "fromName": "深圳",
            "toName": "潍坊",
            "coords": [
              [114.057868, 22.543099],
              [119.161756, 36.706774]
            ]
          }, {
            "fromName": "深圳",
            "toName": "苏州",
            "coords": [
              [114.057868, 22.543099],
              [120.585316, 31.298886]
            ]
          }, {
            "fromName": "深圳",
            "toName": "房山",
            "coords": [
              [114.057868, 22.543099],
              [116.143267, 39.749144]
            ]
          }, {
            "fromName": "深圳",
            "toName": "即墨",
            "coords": [
              [114.057868, 22.543099],
              [120.447128, 36.389639]
            ]
          }, {
            "fromName": "深圳",
            "toName": "舒兰",
            "coords": [
              [114.057868, 22.543099],
              [126.965607, 44.406106]
            ]
          }, {
            "fromName": "深圳",
            "toName": "延吉",
            "coords": [
              [114.057868, 22.543099],
              [129.508946, 42.891255]
            ]
          }, {
            "fromName": "深圳",
            "toName": "三河",
            "coords": [
              [114.057868, 22.543099],
              [117.078295, 39.982718]
            ]
          }, {
            "fromName": "深圳",
            "toName": "大连",
            "coords": [
              [114.057868, 22.543099],
              [121.614682, 38.914003]
            ]
          }, {
            "fromName": "深圳",
            "toName": "辉南",
            "coords": [
              [114.057868, 22.543099],
              [126.046912, 42.684993]
            ]
          }, {
            "fromName": "深圳",
            "toName": "无锡",
            "coords": [
              [114.057868, 22.543099],
              [120.31191, 31.49117]
            ]
          }, {
            "fromName": "深圳",
            "toName": "常州",
            "coords": [
              [114.057868, 22.543099],
              [119.973987, 31.810689]
            ]
          }, {
            "fromName": "深圳",
            "toName": "广西",
            "coords": [
              [114.057868, 22.543099],
              [108.327546, 22.815478]
            ]
          }, {
            "fromName": "深圳",
            "toName": "泉州",
            "coords": [
              [114.057868, 22.543099],
              [118.675676, 24.874132]
            ]
          }, {
            "fromName": "深圳",
            "toName": "昌平",
            "coords": [
              [114.057868, 22.543099],
              [116.231204, 40.22066]
            ]
          }, {
            "fromName": "深圳",
            "toName": "海阳",
            "coords": [
              [114.057868, 22.543099],
              [121.158434, 36.776378]
            ]
          }, {
            "fromName": "深圳",
            "toName": "郑州",
            "coords": [
              [114.057868, 22.543099],
              [113.625368, 34.7466]
            ]
          }, {
            "fromName": "深圳",
            "toName": "东城",
            "coords": [
              [114.057868, 22.543099],
              [116.416357, 39.928353]
            ]
          }, {
            "fromName": "深圳",
            "toName": "黄骅",
            "coords": [
              [114.057868, 22.543099],
              [117.330048, 38.371383]
            ]
          }, {
            "fromName": "深圳",
            "toName": "武侯",
            "coords": [
              [114.057868, 22.543099],
              [104.04339, 30.641982]
            ]
          }, {
            "fromName": "深圳",
            "toName": "鸡东",
            "coords": [
              [114.057868, 22.543099],
              [131.12408, 45.260412]
            ]
          }, {
            "fromName": "深圳",
            "toName": "龙口",
            "coords": [
              [114.057868, 22.543099],
              [120.477813, 37.646108]
            ]
          }, {
            "fromName": "深圳",
            "toName": "汤原",
            "coords": [
              [114.057868, 22.543099],
              [129.905072, 46.730706]
            ]
          }, {
            "fromName": "深圳",
            "toName": "湖北",
            "coords": [
              [114.057868, 22.543099],
              [114.341862, 30.546498]
            ]
          }, {
            "fromName": "深圳",
            "toName": "克拉玛依",
            "coords": [
              [114.057868, 22.543099],
              [84.889207, 45.579889]
            ]
          }, {
            "fromName": "深圳",
            "toName": "厦门",
            "coords": [
              [114.057868, 22.543099],
              [118.089425, 24.479834]
            ]
          }, {
            "fromName": "深圳",
            "toName": "哈尔滨",
            "coords": [
              [114.057868, 22.543099],
              [126.534967, 45.803775]
            ]
          }, {
            "fromName": "深圳",
            "toName": "秦皇岛",
            "coords": [
              [114.057868, 22.543099],
              [119.600493, 39.935385]
            ]
          }, {
            "fromName": "深圳",
            "toName": "江苏",
            "coords": [
              [114.057868, 22.543099],
              [118.763232, 32.061707]
            ]
          }, {
            "fromName": "深圳",
            "toName": "常熟",
            "coords": [
              [114.057868, 22.543099],
              [120.752481, 31.654376]
            ]
          }, {
            "fromName": "深圳",
            "toName": "烟台",
            "coords": [
              [114.057868, 22.543099],
              [121.447935, 37.463822]
            ]
          }, {
            "fromName": "深圳",
            "toName": "和平",
            "coords": [
              [114.057868, 22.543099],
              [117.21451, 39.116949]
            ]
          }, {
            "fromName": "深圳",
            "toName": "环翠",
            "coords": [
              [114.057868, 22.543099],
              [122.123444, 37.501991]
            ]
          }, {
            "fromName": "深圳",
            "toName": "宣武门外东大街",
            "coords": [
              [114.057868, 22.543099],
              [116.378888, 39.899332]
            ]
          }, {
            "fromName": "深圳",
            "toName": "张家港",
            "coords": [
              [114.057868, 22.543099],
              [120.553284, 31.870367]
            ]
          }, {
            "fromName": "深圳",
            "toName": "临安",
            "coords": [
              [114.057868, 22.543099],
              [119.724733, 30.233873]
            ]
          }, {
            "fromName": "深圳",
            "toName": "延安",
            "coords": [
              [114.057868, 22.543099],
              [109.489727, 36.585455]
            ]
          }, {
            "fromName": "深圳",
            "toName": "天津",
            "coords": [
              [114.057868, 22.543099],
              [117.200983, 39.084158]
            ]
          }, {
            "fromName": "深圳",
            "toName": "城阳",
            "coords": [
              [114.057868, 22.543099],
              [120.39631, 36.307064]
            ]
          }, {
            "fromName": "深圳",
            "toName": "石景山",
            "coords": [
              [114.057868, 22.543099],
              [116.222982, 39.906611]
            ]
          }, {
            "fromName": "深圳",
            "toName": "长沙",
            "coords": [
              [114.057868, 22.543099],
              [112.938814, 28.228209]
            ]
          }, {
            "fromName": "深圳",
            "toName": "安徽",
            "coords": [
              [114.057868, 22.543099],
              [117.284923, 31.861184]
            ]
          }, {
            "fromName": "深圳",
            "toName": "昆山",
            "coords": [
              [114.057868, 22.543099],
              [120.980737, 31.385598]
            ]
          }, {
            "fromName": "深圳",
            "toName": "徐汇",
            "coords": [
              [114.057868, 22.543099],
              [121.436525, 31.188523]
            ]
          }, {
            "fromName": "深圳",
            "toName": "东港",
            "coords": [
              [114.057868, 22.543099],
              [124.152705, 39.863008]
            ]
          }, {
            "fromName": "深圳",
            "toName": "廊坊",
            "coords": [
              [114.057868, 22.543099],
              [116.683752, 39.538047]
            ]
          }, {
            "fromName": "深圳",
            "toName": "鞍山",
            "coords": [
              [114.057868, 22.543099],
              [122.994329, 41.108647]
            ]
          }, {
            "fromName": "深圳",
            "toName": "海陵",
            "coords": [
              [114.057868, 22.543099],
              [119.919425, 32.491016]
            ]
          }, {
            "fromName": "深圳",
            "toName": "黑龙江",
            "coords": [
              [114.057868, 22.543099],
              [126.661669, 45.742347]
            ]
          }, {
            "fromName": "深圳",
            "toName": "西藏",
            "coords": [
              [114.057868, 22.543099],
              [91.117212, 29.646923]
            ]
          }, {
            "fromName": "深圳",
            "toName": "河南",
            "coords": [
              [114.057868, 22.543099],
              [113.274379, 34.445122]
            ]
          }, {
            "fromName": "深圳",
            "toName": "湖南",
            "coords": [
              [114.057868, 22.543099],
              [112.98381, 28.112444]
            ]
          }, {
            "fromName": "深圳",
            "toName": "佛山",
            "coords": [
              [114.057868, 22.543099],
              [113.121416, 23.021548]
            ]
          }, {
            "fromName": "深圳",
            "toName": "珲春",
            "coords": [
              [114.057868, 22.543099],
              [130.366036, 42.862821]
            ]
          }, {
            "fromName": "深圳",
            "toName": "扬州",
            "coords": [
              [114.057868, 22.543099],
              [119.412966, 32.39421]
            ]
          }, {
            "fromName": "深圳",
            "toName": "日照",
            "coords": [
              [114.057868, 22.543099],
              [119.526888, 35.416377]
            ]
          }, {
            "fromName": "深圳",
            "toName": "唐山",
            "coords": [
              [114.057868, 22.543099],
              [118.180194, 39.630867]
            ]
          }, {
            "fromName": "深圳",
            "toName": "同江",
            "coords": [
              [114.057868, 22.543099],
              [132.510919, 47.642707]
            ]
          }, {
            "fromName": "深圳",
            "toName": "荣成",
            "coords": [
              [114.057868, 22.543099],
              [122.486658, 37.16516]
            ]
          }, {
            "fromName": "深圳",
            "toName": "虎林",
            "coords": [
              [114.057868, 22.543099],
              [132.93721, 45.762686]
            ]
          }, {
            "fromName": "深圳",
            "toName": "武汉",
            "coords": [
              [114.057868, 22.543099],
              [114.305393, 30.593099]
            ]
          }, {
            "fromName": "深圳",
            "toName": "合肥",
            "coords": [
              [114.057868, 22.543099],
              [117.227239, 31.820587]
            ]
          }, {
            "fromName": "深圳",
            "toName": "荆州",
            "coords": [
              [114.057868, 22.543099],
              [112.239741, 30.335165]
            ]
          }, {
            "fromName": "深圳",
            "toName": "丰台",
            "coords": [
              [114.057868, 22.543099],
              [116.287149, 39.858427]
            ]
          }, {
            "fromName": "深圳",
            "toName": "山东",
            "coords": [
              [114.057868, 22.543099],
              [117.020359, 36.66853]
            ]
          }, {
            "fromName": "深圳",
            "toName": "舟山",
            "coords": [
              [114.057868, 22.543099],
              [122.207216, 29.985295]
            ]
          }, {
            "fromName": "深圳",
            "toName": "连云港",
            "coords": [
              [114.057868, 22.543099],
              [119.221611, 34.596653]
            ]
          }, {
            "fromName": "深圳",
            "toName": "西安",
            "coords": [
              [114.057868, 22.543099],
              [108.940175, 34.341568]
            ]
          }, {
            "fromName": "深圳",
            "toName": "济南",
            "coords": [
              [114.057868, 22.543099],
              [117.12, 36.651216]
            ]
          }, {
            "fromName": "深圳",
            "toName": "绵阳",
            "coords": [
              [114.057868, 22.543099],
              [104.679114, 31.46745]
            ]
          }, {
            "fromName": "深圳",
            "toName": "辽宁",
            "coords": [
              [114.057868, 22.543099],
              [123.42944, 41.835441]
            ]
          }, {
            "fromName": "深圳",
            "toName": "山西",
            "coords": [
              [114.057868, 22.543099],
              [112.562398, 37.873532]
            ]
          }, {
            "fromName": "深圳",
            "toName": "呼和浩特",
            "coords": [
              [114.057868, 22.543099],
              [111.749181, 40.842585]
            ]
          }, {
            "fromName": "深圳",
            "toName": "河西",
            "coords": [
              [114.057868, 22.543099],
              [117.223372, 39.109563]
            ]
          }, {
            "fromName": "深圳",
            "toName": "兴和",
            "coords": [
              [114.057868, 22.543099],
              [113.834173, 40.872301]
            ]
          }, {
            "fromName": "深圳",
            "toName": "重庆",
            "coords": [
              [114.057868, 22.543099],
              [106.551557, 29.56301]
            ]
          }, {
            "fromName": "深圳",
            "toName": "胶州",
            "coords": [
              [114.057868, 22.543099],
              [120.033382, 36.26468]
            ]
          }, {
            "fromName": "深圳",
            "toName": "宁波",
            "coords": [
              [114.057868, 22.543099],
              [121.550357, 29.874557]
            ]
          }, {
            "fromName": "深圳",
            "toName": "滨海",
            "coords": [
              [114.057868, 22.543099],
              [119.820831, 33.990334]
            ]
          }, {
            "fromName": "深圳",
            "toName": "太原",
            "coords": [
              [114.057868, 22.543099],
              [112.548879, 37.87059]
            ]
          }, {
            "fromName": "深圳",
            "toName": "鸡西",
            "coords": [
              [114.057868, 22.543099],
              [130.969333, 45.295075]
            ]
          }, {
            "fromName": "深圳",
            "toName": "兰山",
            "coords": [
              [114.057868, 22.543099],
              [118.347707, 35.051729]
            ]
          }, {
            "fromName": "深圳",
            "toName": "阳泉",
            "coords": [
              [114.057868, 22.543099],
              [113.580519, 37.856972]
            ]
          }, {
            "fromName": "深圳",
            "toName": "勃利",
            "coords": [
              [114.057868, 22.543099],
              [130.592171, 45.755063]
            ]
          }, {
            "fromName": "深圳",
            "toName": "长春",
            "coords": [
              [114.057868, 22.543099],
              [125.323544, 43.817072]
            ]
          }]
        }

      });


    }, 1000);
  }


  render() {
    const {   } = this.props;
    //const { detailsList,mapData} = this.state;
    const {mapData} = this.state;
    // 定义较小的高度
    //const chartHeight = '8rem';
    return (
      <CenterPage>
        <Map mapData={mapData}></Map>
        <CenterBottom>
          <div className='detail-list'>
            {/*<div className="chart-header">*/}
            {/*  <h3>今日总收益: {totalEarnings} 元</h3>*/}
            {/*</div>*/}
            <ChartContainer className='detail-list-item'>
              {/* ECharts 容器 */}
              <div
                ref={this.chartRef}
                style={{width: '110%', height: '100%'}}
              ></div>
            </ChartContainer>
          </div>
        </CenterBottom>
        {/*<CenterBottom>*/}
        {/*  <div className='detail-list'>*/}
        {/*    {detailsList*/}
        {/*      ? detailsList.map((item, index) => {*/}
        {/*        return (*/}
        {/*          <div className='detail-list-item' key={index}>*/}
        {/*            /!* <img*/}
        {/*                src={require(`../../assets/images/center-details-data${*/}
        {/*                  index + 1*/}
        {/*                }.png`)}*/}
        {/*                alt={item.title}*/}
        {/*              /> *!/*/}
        {/*            <div className='detail-item-text'>*/}

        {/*              <span>{item.number}</span>*/}
        {/*              <h3>{item.title}</h3>*/}

        {/*            </div>*/}
        {/*          </div>*/}
        {/*        );*/}
        {/*      })*/}
        {/*      : ''}*/}
        {/*  </div>*/}
        {/*</CenterBottom>*/}
      </CenterPage>
    );
  }
}

const mapStateToProps = state => {
  return {
    //detailsList: state.centerPage.detailsList,
    //detailsList: state.detailsList,
    //mapData: state.centerPage.mapData,
    mapData: state.mapData,
  };
};

const mapStateToDispatch = dispatch => ({});

export default connect(mapStateToProps, mapStateToDispatch)(index);
